var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState, useEffect } from "react";
import { fetchUserObject } from '../helper';
import { verifyUserAccount } from '../../helper';
import { loadRazorPayScript, createOrder, initiateRazorpayPayment } from './api';
import { enableCardFormEvent, publishAppLoading, publishErrorUpdate } from '../../Events/utils.events';
import { getStorageItem } from '../../../helpers/storageManager';
import OfferCode from "./OfferCode";
import './styles.scss';
var RazorPay = function (props) {
    var _a, _b, _c, _d, _e, _f;
    var _g = __read(useState(true), 2), isDisabled = _g[0], setIsDisabled = _g[1];
    var _h = __read(useState(''), 2), emailId = _h[0], setEmailId = _h[1];
    var _j = __read(useState(''), 2), phoneNumber = _j[0], setPhoneNumber = _j[1];
    var getCustomerDetails = function () {
        var _a, _b;
        var store = getStorageItem('CheckoutStore');
        var userEmailId = (_a = store === null || store === void 0 ? void 0 : store.userDetails) === null || _a === void 0 ? void 0 : _a.e;
        setEmailId(userEmailId);
        var userPhoneNumber = (_b = store === null || store === void 0 ? void 0 : store.userDetails) === null || _b === void 0 ? void 0 : _b.p;
        setPhoneNumber(userPhoneNumber);
    };
    var buttonEnabled = function (data) {
        setIsDisabled(data);
        getCustomerDetails();
    };
    useEffect(function () {
        loadRazorPayScript().then(function () {
            publishAppLoading(false);
        }).catch(function (error) {
            publishAppLoading(false);
            console.error("Error loading Razorpay script:", error);
        });
        enableCardFormEvent(buttonEnabled);
    }, []);
    useEffect(function () {
        var userObject = fetchUserObject();
        var userEmail = userObject === null || userObject === void 0 ? void 0 : userObject.email;
        var userPhoneNumber = userObject === null || userObject === void 0 ? void 0 : userObject.phoneNumber;
        if (userEmail || userPhoneNumber) {
            setIsDisabled(false);
            setEmailId(userEmail || '');
            setPhoneNumber(userPhoneNumber || '');
        }
    }, [isDisabled]);
    var handlePaymentInitiation = function () {
        publishAppLoading(true);
        verifyUserAccount()
            .then(function (userCreatedRes) {
            if ((userCreatedRes === null || userCreatedRes === void 0 ? void 0 : userCreatedRes.userCreated) || (userCreatedRes === null || userCreatedRes === void 0 ? void 0 : userCreatedRes.userAlreadyCreated)) {
                createOrder({ userId: userCreatedRes === null || userCreatedRes === void 0 ? void 0 : userCreatedRes.id, emailId: emailId, phoneNumber: phoneNumber })
                    .then(function (orderData) {
                    console.log("Order created successfully:", orderData);
                    if (orderData === null || orderData === void 0 ? void 0 : orderData.id) {
                        initiateRazorpayPayment({ emailId: emailId, phoneNumber: phoneNumber, orderId: orderData === null || orderData === void 0 ? void 0 : orderData.id, amount: orderData === null || orderData === void 0 ? void 0 : orderData.amount, currency: orderData === null || orderData === void 0 ? void 0 : orderData.currency, receipt: orderData === null || orderData === void 0 ? void 0 : orderData.receipt });
                    }
                    else {
                        var errorMessage = "Order ID not found in response:" + orderData;
                        publishErrorUpdate(errorMessage);
                    }
                    publishAppLoading(false);
                }).catch(function (errorMsg) {
                    publishErrorUpdate((errorMsg === null || errorMsg === void 0 ? void 0 : errorMsg.error) || errorMsg || "Error creating order");
                    publishAppLoading(false);
                });
            }
            else {
                publishErrorUpdate("Not receiving user details.");
                publishAppLoading(false);
            }
        }).catch(function (error) {
            var errorMessage = "Error in verifyUserAccount:" + error;
            publishErrorUpdate(errorMessage);
            publishAppLoading(false);
        });
    };
    var payButtonText = ((_c = (_b = (_a = props === null || props === void 0 ? void 0 : props.checkoutModuleData) === null || _a === void 0 ? void 0 : _a.moduleData) === null || _b === void 0 ? void 0 : _b.metadataMap) === null || _c === void 0 ? void 0 : _c.payButtonText) || 'Pay';
    return (React.createElement("div", { className: "razorpay-wrapper" },
        React.createElement(OfferCode, { moduleData: (_d = props === null || props === void 0 ? void 0 : props.checkoutModuleData) === null || _d === void 0 ? void 0 : _d.moduleData, metadataMap: (_f = (_e = props === null || props === void 0 ? void 0 : props.checkoutModuleData) === null || _e === void 0 ? void 0 : _e.moduleData) === null || _f === void 0 ? void 0 : _f.metadataMap, isDisabled: isDisabled }),
        React.createElement("div", { className: "razorpay-container" },
            React.createElement("button", { id: "razorpay-button", disabled: isDisabled, onClick: handlePaymentInitiation, className: "pay-button ".concat(isDisabled ? 'disabled-button' : 'active-button') }, payButtonText))));
};
export default RazorPay;
